<template id="colorTemplate">
  <div class="component-container">
    <app-navigation></app-navigation>
    <form
      :class="formState.invalidShake ? 'invalid' : ''"
      :disabled="formState.loading"
      class="color-form"
    >
      <fieldset>
        <legend>Add new Color</legend>
        <div
          v-if="errors.length && formState.attempted && !formState.loading"
          class="col-12 col-sm-12"
        >
          <b class="w-100">Please correct the following error(s):</b>
          <ul>
            <li v-for="(error, index) in errors" :key="index">{{ error }}</li>
          </ul>
        </div>
        <div class="row">
          <div class="form-group col-12 col-sm-6">
            <label class="col-12 col-sm-4">Name</label>
            <input
              class="form-control"
              type="text"
              maxlength="200"
              v-model="name"
              placeholder="Name"
            />
          </div>
          <div class="form-group col-sm-6">
            <label class="col-12 col-sm-4">Name(EN)</label>
            <input
              class="form-control"
              type="text"
              maxlength="200"
              v-model="nameEN"
              placeholder="Name(EN)"
            />
          </div>
          <div class="col-sm-12">
            <strong>
              Please use an image that has an aspect ratio of
              <br />
              1 : {{ parseFloat(50 / 100).toFixed(2) }} (W : H) - Example:
              100x50
              <br />
              Ignoring this may cause distortion of the image on the website
            </strong>
            <br />
          </div>

          <div class="form-group col-sm-6">
            <label class="col-12 col-sm-12">Image</label>
            <input
              class="form-control-file"
              type="file"
              id="image"
              @change="uploadFile('image')"
              :disabled="formState.loading"
            />
          </div>

          <div class="col-sm-6 text-center">
            <button
              :disabled="formState.loading"
              type="button"
              v-on:click="submitNewColor()"
              class="btn btn-primary"
            >
              Add Color
            </button>
          </div>
          <div class="col-md-12">
            <table class="table mt-5">
              <thead class="thead-light table-striped table-hover">
                <tr>
                  <th scope="col">#</th>
                  <th scope="col">Name</th>
                  <th scope="col">Name En</th>
                  <th scope="col">Image</th>
                  <th scope="col">Actions</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="color in colors" :key="color.id">
                  <th scope="row">{{ color.id }}</th>
                  <td>{{ color.name_ar }}</td>
                  <td>{{ color.name_en }}</td>
                  <td>
                    <img :src="color.image" :alt="color.name_en" width="60px" />
                  </td>
                  <td>
                    <span
                      class="badge badge-danger p-2"
                      @click="deleteColor(color.id)"
                      ><i class="fa fa-trash" aria-hidden="true"></i
                    ></span>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </fieldset>
    </form>
  </div>
</template>


<!-- color Template -->




<style lang='scss' scoped>
@import url("https://fonts.googleapis.com/css?family=PT+Sans");
@import "../../node_modules/bootstrap/scss/bootstrap.scss";
.modified-dropdown {
  -webkit-appearance: menulist;
  background: none;
}
.component-container {
  min-height: 100%;
  display: flex;
}
.color-form {
  float: right;
  padding: 50px;
  width: 80%;
  text-align: left;
  label {
    padding-left: 0;
  }

  div {
    padding: 10px;
  }

  button {
    margin: 0 auto;
    padding: 10px 30px;
    font-size: 16px;
  }
}
.invalid {
  animation: shake 0.82s infinite cubic-bezier(0.36, 0.07, 0.19, 0.97) both;
  transform: translate3d(0, 0, 0);
}

@keyframes shake {
  10%,
  90% {
    transform: translate3d(-1px, 0, 0);
  }

  20%,
  80% {
    transform: translate3d(2px, 0, 0);
  }

  30%,
  50%,
  70% {
    transform: translate3d(-4px, 0, 0);
  }

  40%,
  60% {
    transform: translate3d(4px, 0, 0);
  }
}
</style>

<script>
import axios from "axios";
/* eslint-disable no-unused-vars */
import VueAxios from "vue-axios";
import { constants } from "crypto";
/* eslint-enable no-unused-vars*/
import { herokuUrl } from "../apiConfig";
import { getCookie } from "../cookie.js";
import Navigation from "../components/Navigation.vue";
import logOut from "../scripts/utils";

export default {
  name: "AddColor",
  data() {
    return {
      errors: [],
      colors: [],
      name: "",
      nameEN: "",
      image: {
        uploaded: null,
        newFileUpload: null,
        value: null,
      },
      formState: {
        attempted: false,
        invalidShake: false,
        loading: false,
      },
      compressedFile: null,
      compressedFileFlag: false,
    };
  },
  watch: {
    name: function () {
      this.checkForm();
    },
    nameEN: function () {
      this.checkForm();
    },
    "image.uploaded": function() {
      this.checkForm();
    }
  },
  mounted() {
    this.fetchColors();
    this.checkForm();
  },
  methods: {
    deleteColor: function (id) {
      this.formState.loading = true;
      console.log("submitted" + id);
      return axios
        .post(
          `${herokuUrl}/delete_shoe_color`,
          { id: id },
          {
            headers: {
              Authorization: getCookie("user"),
            },
          }
        )
        .then(() => {
          alert("Color Has Been Deleted Successfully");
          this.size = {};
          this.fetchColors();
          this.formState.loading = false;
        })
        .catch((err) => {
          if (err.response.status == 401) {
            logOut();
          } else {
            this.formState.loading = false;
            alert(
              "There was a problem when Deleting color " +
                err.response.data.message
            );
          }
        });
    },
    compress(elem) {
      const width = 75;
      const height = 45;
      const fileName = elem.files[0].name;
      const reader = new FileReader();
      console.log(elem.files[0]);
      reader.readAsDataURL(elem.files[0]);
      return (reader.onload = (event) => {
        const img = new Image();
        img.src = event.target.result;
        (img.onload = () => {
          const elem = document.createElement("canvas");
          elem.width = width;
          elem.height = height;
          const ctx = elem.getContext("2d");
          // img.width and img.height will contain the original dimensions
          ctx.drawImage(img, 0, 0, width, height);
          ctx.canvas.toBlob(
            (blob) => {
              const file = new File([blob], fileName, {
                type: "image/jpeg",
                lastModified: Date.now(),
              });
              this.compressedFileFlag = true;
              this.compressedFile = file;
            },
            "image/jpeg",
            1
          );
        }),
          (reader.onerror = (error) => {
            this.compressedFileFlag = "error";
            console.log(error);
          });
      });
    },
    // Whenever an input of type file changes, the selected file is uploaded to the backend
    uploadFile() {
      if (
        !(
          document.getElementById("image").files[0] &&
          document.getElementById("image").files[0].name
        )
      )
        return;
      this.formState.loading = true;
      this.image.uploaded = false;
      this.compress(document.getElementById("image"));
      this.image.newFileUpload = new FormData();
      // let file = document.getElementById("image").files[0];
      let fn = () => {
        if (this.compressedFileFlag && this.compressedFileFlag != "error") {
          this.image.newFileUpload.set("images", this.compressedFile);
          axios
            .post(`${herokuUrl}/adminUpload`, this.image.newFileUpload, {
              headers: {
                "Content-Type": "application/x-www-form-urlencoded",
                Authorization: getCookie("user"),
              },
            })
            .then((res) => {
              if (res.data.status) {
                this.image.uploaded = true;
                this.image.value = res.data.sources[0];
                this.formState.loading = false;
              } else {
                alert(
                  "Couldn't Upload file, File too large or    " + res.message
                );
                this.formState.loading = false;
              }
            })
            .catch((err) => {
              console.log(err);
              if (err.response.status == 401) {
                logOut();
              } else {
                alert(
                  "Couldn't Upload file, File too large or    " +
                    err.response.data.message
                );
                this.formState.loading = false;
              }
            });
        } else if (this.compressedFileFlag == "error") {
          alert("Compression Error");
          this.formState.loading = false;
        } else {
          setTimeout(fn, 200);
        }
      };
      fn();
    },
    checkForm: function () {
      this.errors = [];
      if (!this.name) {
        this.errors.push("Name is required");
      }
      if (!this.nameEN) {
        this.errors.push("Name (EN) is required");
      }
      if (!this.image.value) {
        this.errors.push("Image is required");
      }
    },
    fetchColors() {
      this.formState.loading = true;
      return Promise.all([
        axios.get(`${herokuUrl}/shoes_colors`, null, {
          headers: {
            Authorization: getCookie("user"),
          },
        }),
      ])
        .then((res) => {
          console.log(res);
          this.colors = res[0].data["colors"];
          this.formState.loading = false;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    submitNewColor() {
      this.formState.attempted = true;
      if (!this.errors.length) {
        this.formState.loading = true;
        axios
          .post(
            `${herokuUrl}/create_shoe_color`,
            {
              name_ar: this.name,
              name_en: this.nameEN,
              image: this.image.value,
            },
            {
              headers: {
                Authorization: getCookie("user"),
              },
            }
          )
          .then(() => {
            this.formState.loading = false;
            this.formState.attempted = false;
            alert("Color was added successfully");
            this.fetchColors();
          })
          .catch((err) => {
            if (err.response.status == 401) {
              logOut();
            } else {
              this.formState.loading = false;
              alert("There was an error, " + err.response.data.message);
            }
          });
      } else {
        this.shakeForm();
      }
    },
    shakeForm() {
      this.formState.invalidShake = true;
      setTimeout(
        function () {
          this.formState.invalidShake = false;
        }.bind(this),
        820
      );
    },
  },
  components: {
    appNavigation: Navigation,
  },
};
</script>
